import { filterBy } from '@progress/kendo-data-query';
import {
  ComboBox,
  ComboBoxChangeEvent,
  ComboBoxFilterChangeEvent
} from '@progress/kendo-react-dropdowns';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import React, { useEffect, useState } from 'react';
interface Props {
  options: any[];
  optionField: string;
  value: any;
}

export const ComboBoxFilterCell: React.FC<
  React.PropsWithChildren<Props & GridFilterCellProps>
> = props => {
  const { optionField } = props;

  const [options, setOptions] = useState<any[]>([]);
  const [filteredOptions, setFilteredOptions] = useState<any[]>([]);

  useEffect(() => {
    const options = props.options.map(i => i[optionField]);
    setOptions(options);
    setFilteredOptions(options);
  }, [props.options, optionField]);

  const onFilterChange = (event: ComboBoxFilterChangeEvent) => {
    return setFilteredOptions(filterBy(options, event.filter));
  };

  const handleChange = (event: ComboBoxChangeEvent) => {
    const value = event.value;
    props.onChange({
      value: value ?? '',
      operator: value ? 'eq' : '',
      syntheticEvent: event.syntheticEvent
    });
  };

  return (
    <div className="k-filtercell">
      <ComboBox
        data={filteredOptions}
        onChange={handleChange}
        value={props.value}
        filterable={true}
        onFilterChange={onFilterChange}
      />
    </div>
  );
};
